/* Feature List */
function featureli(callback,append){
var featurelist = "";
    $.ajax({
        url: '//www.kontatsu.co.jp/wp/wp-content/themes/kontatsu-child/assets/json/' + callback + '.jsonp',
        type:"GET",
        dataType:"jsonp",
	jsonpCallback: callback,
        error:function() {
//            alert("ロード失敗");
        },
        success: function(json){
	 	var len = json.length;
    		for(var i=0; i < len; i++){
				if(json[i].url != ""){
					featurelist = '<li><a href="' + json[i].url_o + '" target="_top"><div class="recommend_l"><img src="' + json[i].img + '" alt="' + json[i].name + '"></div><div class="recommend_r"><h3>' + json[i].name + '</h3><p>' + json[i].cap + '</p></div></a></li>';
				} else {
					featurelist = '';
				}
   				$(append).append(featurelist);
   			}
		}
    })
};